import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';
import { AccountService } from 'src/app/core/services/account.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { SitefinityService } from 'src/app/core/services/sitefinity.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { IFamilyMember } from 'src/app/model/contract/IContract';
import { UserClaims } from 'src/app/model/okta/userClaims';

@Component({
  selector: 'pgh-edit-avatar-modal',
  templateUrl: './edit-avatar-modal.component.html',
  styleUrls: ['./edit-avatar-modal.component.scss'],
})
export class EditAvatarModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private dialogRef: MatDialogRef<EditAvatarModalComponent>,
    private accountService: AccountService,
    private sitefinityService: SitefinityService,
    private resourcesService: ADPResourceService,
    private loggedInUserSettings: LoggedInUserSettings,
    private storageService: StorageService,
  ) {}

  member: IFamilyMember;
  contract: ISelectedContract;
  user: UserClaims;
  currentAvatar: string;
  currentAvatarColor: string;
  avatarId: string;
  isSaving = false;
  isPrimaryUserLoggedIn: boolean;
  isProfileTab: boolean;

  public colors: string[] = [];

  ngOnInit() {
    this.member = this.dialogData.member;
    this.currentAvatar = this.member.avatarUrl;
    this.contract = this.dialogData.contract;
    this.user = this.dialogData.user;
    this.isProfileTab = this.dialogData.profileTab == undefined ? false : true;
    this.isPrimaryUserLoggedIn = this.contract.primaryUserEmail?.toLowerCase() == this.member.emailAddress?.toLowerCase() ? true : false;

    this.currentAvatarColor = this.dialogData.member.profileColor;
    this.colors = this.resourcesService.getPortalSetting('Global_Avatar_Colors').Value.split(',');
  }

  selectAvatarColor(evt: any) {
    //alert('selected color: ' + evt);
    this.member.profileColor = evt;
  }

  selectAvatar(evt: any) {
    this.member.avatarUrl = evt.url;
  }

  trimUrl(url: string) {
    return url ? url.substr(0, url.lastIndexOf('.png') + 4) : url;
  }

  onCancelClicked() {
    this.member.avatarUrl = this.currentAvatar;
    this.member.profileColor = this.currentAvatarColor;
    this.dialogRef.close({
      data: {
        result: 'failure',
        profileColor: this.member.profileColor,
      },
    });
  }

  onSaveClicked() {
    this.isSaving = true;
    const isEprismOnly = this.storageService.getLocal<string>(`IsEprismOnly`);
    this.accountService
      .putEditMemberAvatar(this.contract.id, this.member.emailAddress, this.member.avatarUrl, this.member.profileColor, isEprismOnly)
      .subscribe(() => {
        this.contract.members.find((m) => m.emailAddress.toLowerCase() === this.member.emailAddress.toLowerCase()).avatarUrl = this.member.avatarUrl;
        this.loggedInUserSettings.setSelectedContract(this.contract);
        this.loggedInUserSettings.clearContractFromCache();
        //this.dialogRef.close();
        this.dialogRef.close({
          data: {
            result: 'success',
            profileColor: this.member.profileColor,
          },
        });
      });
  }

  getViewLabel(item: string) {
    const label = this.resourcesService.getViewLabel(item) ?? '';
    return this.resourcesService.transformContentData(label);
  }
}
